import { Endpoints } from '../api';
import { LOGON_METHOD } from '../components/entities/sys-constants';
import IUser from '../components/entities/user';
import { AccountType } from '../components/login/NativeLogin';
import { setUser } from '../redux/slices/user';
import { store } from '../redux/store';
import { postData } from '../redux/thunks/itemsApi';
import { setCredentials } from './auth/auth.service';
import { IOtpPayload, IVerifyOtpPayload } from './auth/interfaces';



export const handleSendOtp = async (payload: IOtpPayload): Promise<unknown> => {
    const res = await postData<unknown>(Endpoints.sendOTP, payload);
    return res;
};
export const handleVerifyOtp = async (payload: IVerifyOtpPayload): Promise<unknown> => {
    const res = await postData<unknown>(Endpoints.verifyOTP, payload);
    return res;
};

export const handleLoginSuccess = (res: IUser, callBack?: () => void) => {
    setCredentials({
        accessToken: res.accessToken,
        refreshToken: res.refreshToken
    });

    const appUser: IUser = {
        ...res,
        logonMethod: LOGON_METHOD.NATIVE,
        userId: '0',
        accountType: res.accountType || AccountType.USER
    };

    store.dispatch(setUser(appUser));
    if (callBack) callBack();
};
 export const formatMobileNumber = (countryCode: string, number: string) => {
     // add country code to mobile number
     const mobileNumber = `${countryCode}${number}`;
     // add space after every 3 digits
     const formattedMobileNumber = mobileNumber.replace(/(\d{3})/g, '$1 ').trim();
     return formattedMobileNumber;
 };